import { render, staticRenderFns } from "./common-canvas-record-simulation.vue?vue&type=template&id=0bad97e3&scoped=true&"
import script from "./common-canvas-record-simulation.vue?vue&type=script&lang=js&"
export * from "./common-canvas-record-simulation.vue?vue&type=script&lang=js&"
import style0 from "./common-canvas-record-simulation.vue?vue&type=style&index=0&id=0bad97e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bad97e3",
  null
  
)

export default component.exports